/* eslint-disable unicorn/consistent-function-scoping,@typescript-eslint/naming-convention */
/* eslint-disable unicorn/prefer-dom-node-dataset */
// Dependencies
import Glide from '@glidejs/glide';

import { type App } from '~/app';

import './featured-carousel.scss';

export const carousels: Glide[] = [];

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Featured Carousel Component');

    app.afterMount
        .then(() => {
            mountFeaturedCarousel()
        })
        .catch((error: ErrorOptions | undefined) => {
            throw new Error('[Stockland FE] Unable to register Stockland Featured Carousel component', error);
        });

    return function destroyFeaturedCarousel() {
        while (carousels.length > 0) {
            const c = carousels.pop();
            if (c) {
                c.destroy();
            }
        }

        app.logger.debug('[DXA] Feature Links and Image component destroyed');
    };


    function mountFeaturedCarousel(
        root?: HTMLElement | undefined) {
        let rootNode: Document | HTMLElement = document;
        if (root) rootNode = root;

        const isMobile = window.matchMedia("(max-width: 1024px)").matches;

        var config;
        if (document.querySelectorAll('.feature-card-carousel').length) {
            config = {
                type: 'carousel',
                perView: 2.5,
                focusAt: 1,
                startAt: isMobile ? 0 : 1,
                gap: 0,
                peek: {
                    before: 0,
                    after: 0
                },
                breakpoints:{
                    550: {
                        focusAt: "center",
                        perView: 1.4,
                        gap: 4,
                    },
                    1024: {
                        focusAt: "center",
                        perView: 2,
                        gap: 4,
                    },
                    1441: {
                        focusAt: 1,
                        perView: 2.5,
                        gap: 4,
                    }
                }
            }
        } else {
            config = {
                type: 'carousel',
                perView: 3,
                focusAt: 1,
                startAt: isMobile ? 0 : 1,
                gap: 0,
                peek: {
                    before: 0,
                    after: 0
                },
                breakpoints:{
                    1441:{
                        perView: 2,
                        focusAt: "center",
                        peek: {
                            before: 0,
                            after: 280
                        }
                    },
                    1281:{
                        perView: 1.6,
                        focusAt: "center",
                        peek: {
                            before: 0,
                            after: 200
                        }
                    },
                    1024: {
                        perView: 2,
                        focusAt: "center",
                        peek: {
                            before: 0,
                            after: 0
                        }
                    },
                    970: {
                        perView: 1.6,
                        focusAt: "center",
                        peek: {
                            before: 0,
                            after: 0
                        }
                    },
                    768:{
                        perView: 1.6,
                        focusAt: 0,
                        gap: 4,
                        peek: {
                            before: 0,
                            after: 0
                        }

                    },
                    550: {
                        perView: 1.4,
                        focusAt: 0,
                        gap: 4,
                        peek: {
                            before: 0,
                            after: 0
                        }
                    }
                }
            }
        }
        const carouselElements = document.querySelectorAll('.featured-carousel');
        if(carouselElements && carouselElements.length > 0) {
            // @ts-expect-error - Types of property 'type' are incompatible
            const featuredCarouselGlide = new Glide(".featured-carousel", config);
            featuredCarouselGlide.on(['mount.after', 'move'], () => {
                // Remove custom active class from all slides
                for (const slide of document.querySelectorAll('.glide__slide')) slide.classList.remove('glide__slide--active--custom');

                // Add the custom active class to the current slide
                const currentSlideIndices = document.querySelectorAll(`.glide__slides [data-index='${featuredCarouselGlide.index}']`);
                for (const slide of currentSlideIndices) slide.classList.add('glide__slide--active--custom');
            });

            featuredCarouselGlide.mount();

            carousels.push(featuredCarouselGlide as Glide);
        }

        // eslint-disable-next-line unicorn/consistent-function-scoping
        const switchView = (link: Element) => {
            const linkText = link.querySelector('div.link-text');
            const icon = link.querySelector('use');
            const currentIconHref = icon!.getAttribute("xlink:href");
            
            // Find the closest parent that matches the provided link
            let parentCarouselOrGrid = link.closest('.featured-properties');
            if (parentCarouselOrGrid){
                parentCarouselOrGrid = parentCarouselOrGrid.querySelector('.featured-carousel, .featured-grid')
            } else{
                console.log("No parent found in featured property carousel/grid")
                return;
            }
        
            const parentNode = parentCarouselOrGrid!.parentNode
            const map = parentNode!.querySelector('.featured-asset-map')
        
            if (parentCarouselOrGrid!.classList.contains('hidden')) {
                linkText!.textContent = "View as Map";
                const iconHref = currentIconHref!.split('#')[0] + '#' + "location-filled";
                icon!.setAttribute("xlink:href", iconHref);
                parentCarouselOrGrid!.classList.remove('hidden');
                map!.classList.add('hidden')
            } else {
                linkText!.textContent = "View as List";
                const iconHref = currentIconHref!.split('#')[0] + '#' + "hamburger";
                icon!.setAttribute("xlink:href", iconHref);
                parentCarouselOrGrid!.classList.add('hidden');
                map!.classList.remove('hidden')
            }
    
        }
        

        for (const link of rootNode.querySelectorAll('.featured-carousel-map-button')) {
            if (!link.hasAttribute('data-listener-set')){
                link.addEventListener('click', () => switchView(link))
                link.setAttribute('data-listener-set', 'true')
            }

        }

    }
}
